export default "__VITE_ASSET__DzLgJDWg__"